import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { convertStatusString, dateFormation, isEmpty, isMobilePage, toastr } from '../../common/cores';
import { DoQuestion, GetQuestionList } from '../../common/actions/moreAction';
import Answer from './Answer';
import Blank from './Blank';
import Pagenation from '../common/Pagenation';
import { updateUser } from '../../common/actions/userActions';
import BackButton from './BackButton';
import NavLink from 'react-router-dom/NavLink';
const ChangeUserPwd = (props) => {

  const { user } = props;

  console.log(user);
  const [inputs, setInputs] = useState({
    oldPwd: '',
    loginPwd: '',
    loginPwd_confirm: ''
  });
  const { oldPwd, loginPwd, loginPwd_confirm } = inputs;

  //   const dispatch = useDispatch();

  const onChange = (e) => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    setInputs({
      ...inputs, // 기존의 input 객체를 복사한 뒤
      [name]: value // name 키를 가진 값을 value 로 설정
    });
  };

  const onReset = (e) => {

    setInputs({
      oldPwd: "",
      loginPwd: "",
      loginPwd_confirm: ""
    })
  };

  const onSubmit = () => {
    let params = {
      oldPwd,
      loginPwd,
      loginPwd_confirm
    }
    // updateUser(params)
    props.updateUser(params);
    onReset();
  }


  const onEnter = (e) => {
    // e.preventDefault();
    if (e.key === 'Enter') {
      // e.preventDefault();
      onSubmit(e);
    }
  }
  return (
    <Fragment>
      <div className="con_box10">
        <div className="write_wrap">
          <div className="write3">
            <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
              <tbody>
                <tr>
                  <td className="write_title">비번</td>
                  <td className="write_basic">
                    <input
                      name="oldPwd"
                      onChange={onChange}
                      value={oldPwd}

                      type="password"

                      inputMode="text"
                      className="input1"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="write_title">변경할 비밀번호</td>
                  <td className="write_basic">
                    <input
                      name="loginPwd"
                      onChange={onChange}
                      value={loginPwd}

                      type="password"

                      inputMode="text"
                      className="input1"
                    />
                    &nbsp;
                    영문과 숫자를 포함하여 6~16자로 입력해야합니다.(특수문자 X)</td>
                </tr>
                <tr>
                  <td className="write_title">변경할 비밀번호 확인</td>
                  <td className="write_basic">
                    <input
                      name="loginPwd_confirm"
                      onChange={onChange}
                      value={loginPwd_confirm}

                      type="password"

                      inputMode="text"
                      className="input1"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="con_box30">
        <div className="btn_wrap_center">
          <ul>
            <li><a><span className="btn3_1" onClick={onSubmit}>정보수정</span></a></li>
          </ul>
        </div>
      </div>
    </Fragment>

  )
}

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated,
  user: state.user.data
});


export default connect(mapStateToProps, {
  updateUser
})(ChangeUserPwd);


// WEBPACK FOOTER //
// ./src/components/account/ChangeUserPwd.js